import { COLORS } from "styles/colors";
import styled from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import {
  changeColorMapMarkerStatus,
  MarkerWrapper,
} from "./MarkerCommonStyled";
import { MarkerDataType } from "../../GoogleMapContainer";

const showTitle = (props: MarkerDataType) => {
  if (props.groupingSystems.length === 1) {
    return (
      <SystemTitle>
        {props.groupingSystems.map((sys, idx) => (
          <span key={idx}>{sys.mergedSystemName}</span>
        ))}
      </SystemTitle>
    );
  }
  return (
    <>
      <SystemTitle>{props.title}</SystemTitle>
      {props.groupingSystems.length > 1 && (
        <strong>+{props.groupingSystems.length - 1}</strong>
      )}
    </>
  );
};

export default function MergedMarker(props: MarkerDataType): JSX.Element {
  return (
    <Wrapper status={{ ...props.alertStatusCount }}>
      {showTitle(props)}

      <div className="marker-circle-bg"></div>
    </Wrapper>
  );
}

const Wrapper = styled(MarkerWrapper)`
  ${FLEX.FlexCenterCenter};
  gap: 5px;
  padding: 4px 6px;
  border-radius: 8px;
  color: ${COLORS.WHITE};
  z-index: 2;
  position: relative;
  max-width: 150px;
  background-color: ${(props) => changeColorMapMarkerStatus(props.status)};
  user-select: none;
  -webkit-user-drag: none;

  > strong {
    font-weight: bold;
    font-size: ${calcRem(20)};
    flex-shrink: 0;
  }

  :after {
    content: "";
    position: absolute;
    border-style: solid;
    border-width: 20px 8px 0;
    border-color: ${(props) => changeColorMapMarkerStatus(props.status)}
      transparent transparent;
    width: 0;
    bottom: -8px;
    z-index: -1;
  }
`;

const SystemTitle = styled.span`
  font-size: ${calcRem(14)};
  color: ${COLORS.WHITE};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
  min-width: 0;
`;
